/*
* @Author: LH
* @Date:   2019-07-06 18:15:56
* @Last Modified by:   gujianghua
* @Last Modified time: 2019-08-07 09:44:21
*/
import { service,BASE_API } from '@/utils/request'

export default {
	/**
	 * [getDataList 列表]
	 * @param  {[obj]} data [筛选条件]
	 * @return {[obj]}
	 */
	getDataList(params) {
	  return service({
	    url: '/cloud/activity/v1/marketing/admin/course/list',
	    method: 'get',
	    params: params
	  })
	},
	// 获取详情
	getDetail(data) {
	  return service({
	    url: '/cloud/activity/v1/marketing/admin/course/detail',
	    method: 'get',
	    params: data
	  })		
	},
	// 更新
	update(data) {
	  return service({
	    url: '/cloud/activity/v1/marketing/admin/course/edit',
	    method: 'post',
	    data: data
	  })		
	},
	// 创建
	create(data) {
	  return service({
	    url: '/cloud/activity/v1/marketing/admin/course/add',
	    method: 'post',
	    data: data
	  })		
	},
	// 删除
	deleteData(data) {
	  return service({
	    url: '/cloud/activity/v1/marketing/admin/course/delete',
	    method: 'post',
	    params: data
	  })		
	},
	// 结束
	stopLimit(data) {
	  return service({
	    url: '/cloud/activity/v1/marketing/admin/course/stop',
	    method: 'post',
	    params: data
	  })		
	},
}


// WEBPACK FOOTER //
// ./src/api/operateManage/limitSale.js